import React from "react";

export const FeatureIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M16 2.75C16 2.33579 15.6642 2 15.25 2H0.75C0.335787 2 0 2.33579 0 2.75V13.25C0 13.6642 0.335787 14 0.75 14H15.25C15.6642 14 16 13.6642 16 13.25V2.75ZM14.5 3.5V12.5H1.5V3.5H14.5ZM4 7V4.5H2.5V7H4ZM10.5 8C10.5 6.52948 9.5452 5 8 5C6.4548 5 5.5 6.52948 5.5 8C5.5 9.47052 6.4548 11 8 11C9.5452 11 10.5 9.47052 10.5 8ZM8 6.5C8.38779 6.5 9 6.98524 9 8C9 9.01476 8.38779 9.5 8 9.5C7.61221 9.5 7 9.01476 7 8C7 6.98524 7.61221 6.5 8 6.5ZM13.5 11.5V9H12V11.5H13.5Z"
            fill="#6A9A23"
            fillRule="evenodd"
        />
    </svg>
);

export const TaskIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5H3ZM12.3262 5.48014L7.32617 11.4801C7.18367 11.6511 6.97258 11.75 6.75 11.75C6.52742 11.75 6.31633 11.6511 6.17383 11.4801L3.67383 8.48014L4.82617 7.51986L6.75 9.82846L11.1738 4.51986L12.3262 5.48014Z"
            fill="#4688EC"
            fillRule="evenodd"
        />
    </svg>
);

export const StoryIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M4.98291 2.5C4.70677 2.5 4.48291 2.72386 4.48291 3V12.8059L8.00015 10.3332L11.5179 12.806V3C11.5179 2.72386 11.294 2.5 11.0179 2.5H4.98291ZM2.98291 3C2.98291 1.89543 3.87834 1 4.98291 1H11.0179C12.1225 1 13.0179 1.89543 13.0179 3V14.25C13.0179 14.5299 12.862 14.7866 12.6136 14.9156C12.3652 15.0446 12.0656 15.0236 11.8366 14.8626L8.00015 12.1658L4.1642 14.8626C3.9352 15.0236 3.6356 15.0446 3.38718 14.9156C3.13875 14.7866 2.98291 14.5299 2.98291 14.25V3Z"
            fill="#6A9A23"
            fillRule="evenodd"
        />
    </svg>
);

export const BugIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M8 2.5C7.17157 2.5 6.5 3.17157 6.5 4H9.5C9.5 3.17157 8.82843 2.5 8 2.5ZM11 4.02074V4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4V4.02074C4.70952 4.06947 4.44734 4.2017 4.239 4.39189L3.35231 3.75855L2.43536 1.6954L1.06464 2.3046L2.00928 4.43004C2.0999 4.63393 2.24344 4.80985 2.425 4.93953L3.75 5.88596V7H0.5V8.5H3.75V9.64872L2.60021 10.6069C2.46773 10.7173 2.35953 10.8539 2.28241 11.0081L1.07918 13.4146L2.42082 14.0854L3.60066 11.7257L4.06124 11.3419C4.69682 12.9183 6.23827 14 8.00146 14H8.25C9.96908 14 11.4349 12.9156 12.0006 11.3934L12.3993 11.7257L13.5791 14.0854L14.9208 13.4146L13.7176 11.0081C13.6405 10.8539 13.5323 10.7173 13.3998 10.6069L12.25 9.64872V8.5H15.5V7H12.25V5.88596L13.575 4.93953C13.7566 4.80985 13.9001 4.63393 13.9907 4.43004L14.9353 2.3046L13.5646 1.6954L12.6477 3.75855L11.761 4.39189C11.5527 4.2017 11.2905 4.06947 11 4.02074ZM10.75 10V5.5H5.25V9.94265L5.28488 10.1694C5.49117 11.5102 6.64486 12.5 8.00146 12.5H8.25C9.63071 12.5 11 11.3807 11 10Z"
            fill="#F15B50"
            fillRule="evenodd"
        />
    </svg>
);

export const AssetIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M0.219686 0.219656C0.407005 0.032337 0.679247 -0.0422694 0.935891 0.0233837L10.8966 2.5714C11.6642 2.76775 12.2435 3.3987 12.3737 4.18021L13.0165 8.037C13.2765 7.95209 13.5737 8.01295 13.7803 8.21958L15.7803 10.2196C16.0732 10.5124 16.0732 10.9873 15.7803 11.2802L11.2803 15.7802C10.9875 16.0731 10.5126 16.0731 10.2197 15.7802L8.21969 13.7802C8.01306 13.5736 7.9522 13.2764 8.03711 13.0164L4.18032 12.3736C3.39881 12.2434 2.76786 11.6641 2.57151 10.8965L0.0234143 0.935917C-0.0422389 0.679273 0.032367 0.406975 0.219686 0.219656ZM9.81068 13.25L10.75 14.1893L14.1894 10.75L13.25 9.81065L9.81068 13.25ZM11.697 9.24257L9.24278 11.6967L4.42709 10.8941C4.23172 10.8616 4.07398 10.7167 4.02489 10.5248L2.15506 3.21551L5.65846 6.71891C5.55656 6.95888 5.5002 7.22285 5.5002 7.49999C5.5002 8.60456 6.39563 9.49999 7.5002 9.49999C8.60477 9.49999 9.5002 8.60456 9.5002 7.49999C9.5002 6.39542 8.60477 5.49999 7.5002 5.49999C7.22306 5.49999 6.95909 5.55635 6.71912 5.65825L3.21572 2.15485L10.5251 4.02468C10.717 4.07377 10.8717 4.23151 10.9043 4.42688L11.697 9.24257ZM8.0002 7.49999C8.0002 7.22384 7.77634 6.99999 7.5002 6.99999C7.22405 6.99999 7.0002 7.22384 7.0002 7.49999C7.0002 7.77613 7.22405 7.99999 7.5002 7.99999C7.77634 7.99999 8.0002 7.77613 8.0002 7.49999Z"
            fill="#4688EC"
            fillRule="evenodd"
        />
    </svg>
);

export const ContactIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 1.5C5.51472 1.5 3.5 3.51472 3.5 6C3.5 7.55255 4.28559 8.92187 5.48441 9.73183C6.02899 10.0998 6.48633 10.726 6.4997 11.5H9.5003C9.51367 10.726 9.97101 10.0998 10.5156 9.73183C11.7144 8.92187 12.5 7.55255 12.5 6C12.5 3.51472 10.4853 1.5 8 1.5ZM9.5 13H6.5V14C6.5 14.2761 6.72386 14.5 7 14.5H9C9.27614 14.5 9.5 14.2761 9.5 14V13ZM2 6C2 2.68629 4.68629 0 8 0C11.3137 0 14 2.68629 14 6C14 8.0717 12.9494 9.89775 11.3553 10.9747C11.1084 11.1416 11 11.3597 11 11.5348V14C11 15.1046 10.1046 16 9 16H7C5.89543 16 5 15.1046 5 14V11.5348C5 11.3597 4.89163 11.1416 4.64466 10.9747C3.05062 9.89775 2 8.0717 2 6Z"
            fill="#B38600"
        />
    </svg>
);

export const RequestIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5H3ZM7.25 8.75V12H8.75V8.75H12V7.25H8.75V4H7.25V7.25H4V8.75H7.25Z"
            fill="#6A9A23"
            fillRule="evenodd"
        />
    </svg>
);

export const ResearchItemIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="#E06C00">
            <path
                clipRule="evenodd"
                d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 5C7.41421 5 7 5.41421 7 6H5.5C5.5 4.58579 6.58579 3.5 8 3.5C9.41421 3.5 10.5 4.58579 10.5 6C10.5 7.13259 9.78738 7.7057 9.33837 8.05849C8.82691 8.46035 8.75 8.55198 8.75 8.75V9.5H7.25V8.75C7.25 7.77259 7.93895 7.24287 8.32821 6.94359C8.35791 6.92075 8.38586 6.89926 8.41163 6.87901C8.83763 6.5443 9 6.3673 9 6C9 5.41421 8.58579 5 8 5Z"
                fillRule="evenodd"
            />
            <path d="M9 11.5C9 12.0523 8.55228 12.5 8 12.5C7.44772 12.5 7 12.0523 7 11.5C7 10.9477 7.44772 10.5 8 10.5C8.55228 10.5 9 10.9477 9 11.5Z" />
        </g>
    </svg>
);

export const IncidentIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5H9.51305L8.34638 5.5H10.25C10.4976 5.5 10.7292 5.62219 10.869 5.82655C11.0088 6.0309 11.0387 6.29108 10.949 6.52183L9.199 11.0218L7.801 10.4782L9.15362 7H7.25C7.00241 7 6.77077 6.87781 6.63098 6.67345C6.49119 6.4691 6.46128 6.20892 6.551 5.97817L7.90362 2.5H3ZM5.5 7.5H4V9H5.5V7.5ZM10.5 7.5H12V9H10.5V7.5Z"
            fill="#F15B50"
            fillRule="evenodd"
        />
    </svg>
);

export const ServiceRequestIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5H3ZM4 5.5V4H12V5.5H4ZM4 8.5V7H12V8.5H4ZM4 11.5V10H8V11.5H4Z"
            fill="#F15B50"
            fillRule="evenodd"
        />
    </svg>
);

export const SupportIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V9.75C15 10.2691 14.7938 10.7669 14.4268 11.1339L11.1339 14.4268C10.7669 14.7938 10.2691 15 9.75 15H3C1.89543 15 1 14.1046 1 13V3ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H9V9.75C9 9.33579 9.33579 9 9.75 9H13.5V3C13.5 2.72386 13.2761 2.5 13 2.5H3ZM12.9393 10H10.5V12.4393L12.9393 10ZM11 5.5H4V4H11V5.5ZM7 9H4V7.5H7V9Z"
            fill="#4688EC"
            fillRule="evenodd"
        />
    </svg>
);

export const CampaignIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M6.04021 1.52023L3.15132 4.52023C2.99257 4.68509 2.76722 4.76844 2.53939 4.74657C2.31157 4.72469 2.1062 4.59998 1.98172 4.40792L0.870606 2.69364L2.12934 1.87779L2.72641 2.79899L4.95973 0.479766L6.04021 1.52023ZM14.9998 3.5H6.99977V2H14.9998V3.5ZM5.99998 6.79046L3.11109 9.79046C2.95234 9.95532 2.72699 10.0386 2.49916 10.0168C2.27134 9.99492 2.06597 9.87021 1.94149 9.67815L0.830376 7.96387L2.0891 7.14802L2.68618 8.06922L4.9195 5.74999L5.99998 6.79046ZM14.9998 8.77023H6.99977V7.27023H14.9998V8.77023ZM5.99998 12.0605L3.11109 15.0605C2.95234 15.2254 2.72699 15.3087 2.49916 15.2869C2.27134 15.265 2.06597 15.1403 1.94149 14.9482L0.830376 13.2339L2.0891 12.4181L2.68618 13.3393L4.9195 11.02L5.99998 12.0605ZM14.9998 14.0403H6.99977V12.5403H14.9998V14.0403Z"
            fill="#BF63F3"
            fillRule="evenodd"
        />
    </svg>
);

export const CandidateIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 1.5C5.51472 1.5 3.5 3.51472 3.5 6C3.5 7.55255 4.28559 8.92187 5.48441 9.73183C6.02899 10.0998 6.48633 10.726 6.4997 11.5H9.5003C9.51367 10.726 9.97101 10.0998 10.5156 9.73183C11.7144 8.92187 12.5 7.55255 12.5 6C12.5 3.51472 10.4853 1.5 8 1.5ZM9.5 13H6.5V14C6.5 14.2761 6.72386 14.5 7 14.5H9C9.27614 14.5 9.5 14.2761 9.5 14V13ZM2 6C2 2.68629 4.68629 0 8 0C11.3137 0 14 2.68629 14 6C14 8.0717 12.9494 9.89775 11.3553 10.9747C11.1084 11.1416 11 11.3597 11 11.5348V14C11 15.1046 10.1046 16 9 16H7C5.89543 16 5 15.1046 5 14V11.5348C5 11.3597 4.89163 11.1416 4.64466 10.9747C3.05062 9.89775 2 8.0717 2 6Z"
            fill="#B38600"
        />
    </svg>
);

export const IssueTypeIcons = {
    Feature: FeatureIcon,
    Task: TaskIcon,
    Story: StoryIcon,
    Bug: BugIcon,
    Asset: AssetIcon,
    Contact: ContactIcon,
    Request: RequestIcon,
    ResearchItem: ResearchItemIcon,
    Incident: IncidentIcon,
    ServiceRequest: ServiceRequestIcon,
    Support: SupportIcon,
    Campaign: CampaignIcon,
    Candidate: CandidateIcon
};

export type IssueTypeIconName = keyof typeof IssueTypeIcons;

interface IssueTypeIconProps {
    type: IssueTypeIconName;
}

export const IssueTypeIcon: React.FC<IssueTypeIconProps> = ({ type }) => {
    const IconComponent = IssueTypeIcons[type];
    return <IconComponent />;
};
